module.exports = __webpack_public_path__ + "img/adventurealtitude.e337bb38.jpg";